import React, { useEffect } from "react";
import { BiCheckCircle } from "react-icons/bi";

interface AlertProps {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

const AlertSuccess: React.FC<AlertProps> = ({ isOpen, message, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed top-0 left-0 w-full z-50 bg-green-500/90 text-white px-4 py-3 shadow-md flex items-center justify-center gap-2 animate-fade-in cursor-pointer"
      onClick={onClose}
    >
      <BiCheckCircle className="w-5 h-5 text-white" />
      <span className="text-sm sm:text-base font-medium">{message}</span>
    </div>
  );
};

export default AlertSuccess;
